/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Dose_PendingInputs */

const en_us2_plan_build_dose_pending = /** @type {(inputs: Plan_Build_Dose_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wait for the prescription to arrive to edit it.`)
};

const pt_br2_plan_build_dose_pending = /** @type {(inputs: Plan_Build_Dose_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aguarde a prescrição chegar para editar.`)
};

const es_419_plan_build_dose_pending = /** @type {(inputs: Plan_Build_Dose_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espera a que llegue la prescripción para editarla.`)
};

const pt_pt2_plan_build_dose_pending = /** @type {(inputs: Plan_Build_Dose_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espera que a prescrição chegue para a editares.`)
};

const fr_fr2_plan_build_dose_pending = /** @type {(inputs: Plan_Build_Dose_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attends que la prescription arrive pour la modifier.`)
};

const de_de2_plan_build_dose_pending = /** @type {(inputs: Plan_Build_Dose_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warte, bis die Vorgabe da ist, um sie zu bearbeiten.`)
};

const it_it2_plan_build_dose_pending = /** @type {(inputs: Plan_Build_Dose_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aspetta che arrivi la prescrizione per modificarla.`)
};

/**
* | output |
* | --- |
* | "Wait for the prescription to arrive to edit it." |
*
* @param {Plan_Build_Dose_PendingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_dose_pending = /** @type {((inputs?: Plan_Build_Dose_PendingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Dose_PendingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_dose_pending(inputs)
	if (locale === "es-419") return es_419_plan_build_dose_pending(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_dose_pending(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_dose_pending(inputs)
	if (locale === "de-DE") return de_de2_plan_build_dose_pending(inputs)
	if (locale === "it-IT") return it_it2_plan_build_dose_pending(inputs)
	return en_us2_plan_build_dose_pending(inputs)
});
export { plan_build_dose_pending as "plan-build.dose_pending" }